import { Stack } from '@backyard-ui/core'

import { SelectOption } from '../SelectOption'
import { SelectOptionType } from '../../MarketPlace/types'

interface Option {
  key: SelectOptionType | string
  label: string
}

interface SelectOptionsGroupProps {
  options: Option[]
  selected: string
  onClick: (option: SelectOptionType | string) => void
}

const SelectOptionsGroup = (props: Readonly<SelectOptionsGroupProps>) => {
  const { options, onClick, selected } = props
  return (
    <Stack direction="column" className="w-fit inline rounded-lg">
      {options.map((option, index) => (
        <SelectOption
          key={option.key}
          label={option.label}
          isSelected={selected === option.key}
          isDisabled={!!selected}
          onSelect={() => onClick(option.key)}
          isFirst={index === 0}
          isLast={index === options.length - 1}
        />
      ))}
    </Stack>
  )
}

export default SelectOptionsGroup
